import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles, makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { Close, LastPage, AllInclusive, Add, MoreVert, Edit, Delete, Done, Block, Visibility, Gavel, FilterList, FormatListNumbered, ConfirmationNumber, HourglassEmpty, Check } from '@material-ui/icons';

import { withLocalize, Translate } from "react-localize-redux";

import {
    TableRow,
    TablePagination,
    TableFooter,
    TableContainer,
    TableCell,
    TableBody,
    Table,
    TableHead,
    Button,
    IconButton,
    Paper,
    Typography,
    Toolbar,
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    AppBar,
    TextField,
    FormControlLabel,
    Checkbox,
    Container,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Menu,
    TextareaAutosize,
    Chip,
    LinearProgress,
    CircularProgress,
    FormHelperText,
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Avatar,
    Grid,
    Link,
    Slide,
    Input
} from "@material-ui/core";

import Format from "date-fns/format";

import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";

import { useHistory } from "react-router-dom";

import MUIDataTable from "mui-datatables";

import { useSnackbar } from 'notistack';

import { TransportService, ReportingService, AdminService, FinanceService, groupBy } from "../../utils/web_config_2";


import UserInfo from "./login_info";

import DateFnsUtils from "@date-io/date-fns";

import axios from 'axios';

import Chart from 'react-apexcharts'

import Skeleton from '@material-ui/lab/Skeleton';
import Autocomplete from '@material-ui/lab/Autocomplete';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles1 = makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        flexFlow: 1,
        [theme.breakpoints.up('sm')]: {
            marginLeft: 250,
        }
    },
    btn: {
        textTransform: "capitalize",
    },
    formTitle: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        height: 300,
        elevation: 0
    }, appBar: {
        position: 'relative',
    }, title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    }
}));


function ReportPromotion() {
    const classes = useStyles1();


    const [operatorData, setOperatorData] = useState({});

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const [reportsMessage, setReportsMessage] = useState("Loading...");
    const [reportTitle, setReportTitle] = useState("Promotion Report");

    //offenses table 


    const columns = [
			{
				name: 'customer_name',
				label: 'Customer Name',
				options: {
					filter: true,
					sort: true,
					customBodyRender: (value, tableMeta, updateValue) => {
						return (
							<Typography color='primary'>
								<Link href='#' onClick={() => {}}>
									{value}
								</Link>
							</Typography>
						);
					},
				},
			},
			{
				name: 'no_of_trips',
				label: 'No of Trip',
				options: {
					filter: true,
					sort: true,
				},
			},
			{
				name: 'route',
				label: 'Route',
				options: {
					filter: true,
					sort: true,
				},
			},
			{
				name: 'stop',
				label: 'Stop',
				options: {
					filter: true,
					sort: true,
				},
			},
		];


    const options = {
        textLabels: {
            body: {
                noMatch: reportsMessage
            },
        },
        filterType: 'checkbox',
        download: true,
        responsive: "standard",
        selectableRows: false,
        rowsPerPage: 10,
        elevation: 0,
        customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
            <Box>
                <Chip
                    className={classes.chip}
                    icon={<Visibility />}
                    color="primary"
                    variant="outlined"
                    label="View details"
                    onClick={() => {
                        var id = displayData[selectedRows.data[0]['index']]['data'][0];
                        console.log("ticket id", id);
                    }} />
            </Box>
        ),
    };

    useEffect(() => {
        var data = {};
        const data1 = localStorage.getItem("nx_op");
        if (data1 != null) {
            data = JSON.parse(data1);
        }
        setOperatorData(data);
        get_promotion_report();
    }, []);


    const [trips, setTrips] = useState({ value: 1, error: "" });
    const [reportLoad, setReportLoad] = useState(false);
    const [reports, setReports] = useState([]);
    const get_promotion_report = (trip = 1) => {
        setReportLoad(true);
        const data = JSON.parse(localStorage.getItem("nx_op"));
        axios.defaults.baseURL = new TransportService().BASE_URL;
        const reportInstance = axios.create(new TransportService().setHeaders(data["token"]));

        reportInstance.get(`/api/v1/commuters/up-coming-promotions?organisationId=${new UserInfo().ORG_ID}&tripNumber=${trip}`)
            .then(res => {
                var objs = res.data;
                if (objs.length === 0) {
                    setReportsMessage("No report found");
                } else {
                    setReports(objs);
                }
                setReportLoad(false);
                setFilterDialog(false);
            })
            .catch(err => {

                setReportLoad(false);
                if (err.message) {
                    setReportsMessage(err.message);
                    enqueueSnackbar(err.message,
                        {
                            variant: 'error'
                        });
                }

                if (err.response) {
                    setReportsMessage(err.response.data.message);
                    enqueueSnackbar(err.response.data.message,
                        {
                            variant: 'error'
                        });
                }
            });
    }
    // filter dialog 
    const [filterDialog, setFilterDialog] = useState(false);


    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <div className={classes.root}>
                <Box display='flex'>
                    <Box
                        display='flex'
                        alignItems='center'
                        mt={2}
                        className={classes.formTitle}
                    >
                        <Box mr={1}>
                            <ConfirmationNumber fontSize='large' color='primary' />
                        </Box>{' '}
                        <Typography variant='h5' color='default'>
                            <b>Promotion Report</b>
                        </Typography>
                    </Box>

                    <Button
                        color='primary'
                        variant='outlined'
                        startIcon={<FilterList />}
                        onClick={() => {
                            setFilterDialog(true);
                        }}
                    >
                        Filter
                    </Button>
                </Box>

                <Box mt={2}>
                    <Grid container spacing={2}>
                    
                        <Grid item md={12} lg={12} sm={12} xs={12}>
                            {reportLoad && <LinearProgress />}
                            <MUIDataTable
                                title={reportTitle}
                                data={reports}
                                columns={columns}
                                options={options}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </div>

            {/* filter dialog  */}

            <Dialog
                maxWidth='sm'
                fullWidth
                open={filterDialog}
                onClose={() => {
                    setFilterDialog(true);
                }}
                aria-labelledby='filter'
                aria-describedby='filter'
            >
                <DialogTitle id='filter'>{'Filter'}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Box>
                            <Box mt={1}>
                                <TextField
                                    autoFocus
                                    size='small'
                                    variant='outlined'
                                    type='number'
                                    error={trips.error !== ""}
                                    helperText={trips.error}
                                    value={trips.value}
                                    onChange={(e) => {
                                        var data = e.target.value;
                                        setTrips({ value: data, error: "" });

                                    }}
                                    label={"No of Trip"}
                                    color='primary' fullWidth />
                            </Box>
                        </Box>
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={() => {
                            setFilterDialog(false);
                        }}
                        color='secondary'
                        className={classes.btn}
                    >
                        <Typography>Close</Typography>
                    </Button>

                    <Button
                        onClick={() => {
                            get_promotion_report(trips.value);
                        }}
                        color='primary'
                        variant='contained'
                        className={classes.btn}
                    >
                        {reportLoad ? (
                            <CircularProgress size={25} color='secondary' />
                        ) : (
                            <Typography>View</Typography>
                        )}
                    </Button>
                </DialogActions>
            </Dialog>

        </MuiPickersUtilsProvider>
    );
}

export default withLocalize(ReportPromotion);
